"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var VideoLayerComponent = function VideoLayerComponent(_ref) {
  var url = _ref.url,
      setUrl = _ref.setUrl;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, url && /*#__PURE__*/_react["default"].createElement("div", {
    className: "video-spot-overlay video-layer",
    onClick: function onClick() {
      return setUrl('');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "video-spot-overlay-close",
    onClick: function onClick() {
      return setUrl('');
    }
  }), url.indexOf('iframe') > -1 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "video-spot-overlay-video",
    dangerouslySetInnerHTML: {
      __html: url
    }
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "video-spot-overlay-video"
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    src: url
  }))));
};

var _default = VideoLayerComponent;
exports["default"] = _default;